import React, { useRef } from 'react';
import { Typography, Box } from '@mui/material';
import { useTranslation } from 'services/localization/useTranslation';
import ActionDialog from 'common/components/ActionDialog';

interface Props {
	open: boolean;
	productCount: number;
	onClose: () => void;
	handleDelete: () => void;
	loading: boolean;
}

const DeleteArticlesDialog = (props: Props) => {
	const { t } = useTranslation();
	const { productCount, open, onClose, handleDelete, loading } = props;
	const count = useRef(productCount);

	return open ? (
		<ActionDialog
			title={t('deleteArticlesDialog.deleteArticles', 'Delete articles')}
			headerVariant="contained"
			btnActions={{
				primary: {
					text: t('common:actions.yesDelete', 'Yes, delete'),
					onClick: handleDelete,
					loading,
					disabled: loading,
				},
				secondary: {
					text: t('common:actions.no', 'No'),
					onClick: onClose,
				},
			}}
			onClose={onClose}
			variant="danger"
		>
			<>
				<Box pb={2}>
					<Typography>
						{t('deleteArticlesDialog.deleteConfirm', {
							productCount: count.current,
							defaultValue: 'Are you sure you want to delete selected {{productCount}} articles',
						})}
						?
					</Typography>
				</Box>
				<Box pb={2}>
					<Typography>
						{t('deleteArticlesDialog.deleteInfo', 'This action cannot be undone')}.
					</Typography>
				</Box>
			</>
		</ActionDialog>
	) : null;
};

export default DeleteArticlesDialog;
